'use client'
import { useUserAuthModal } from '@repo/user-auth-dialog/user-auth-dialog-context'
import { Button } from '@repo/design-system-cf/components/button'

export function Login({ children }: { children: React.ReactNode }) {
  const { openModal } = useUserAuthModal()
  const handleClick = () => {
    openModal('login')
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="custom"
      onClick={handleClick}
      className="inline min-h-0 p-0 text-blue-500 hover:text-secondary-500"
    >
      {children}
    </Button>
  )
}
